var borders_default = {
  "borderT": "_0JNXr",
  "borderB": "JhNV5",
  "borderL": "KXAoO",
  "borderR": "VM5SM",
  "borderColorOverride": "Acng8"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
